/**
 * Created by dorin on 6/22/17.
 */
import React from 'react';
import { connect } from 'react-redux';
import { Form, FormGroup, FormControl } from 'react-bootstrap';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';

class ResetPassword extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      password: '',
      confirmPassword: '',
    };
  }

  componentDidMount() {
    const uid = this.props.params.uid;
    const token = this.props.params.token;

    this.props.dispatch(actions.retrieveEmail(uid, token));
  }

  componentWillReceiveProps(nextProps) {
    const { status, error, dispatch } = nextProps;

    if (status === actionTypes.AUTH_EMAIL_ERROR) {
      dispatch(actions.alert('error', 'Unable to log in, please try again.'));
    } else if (status === actionTypes.AUTH_RESET_ERROR) {
      if (error) {
        const errors = Object.values(error);
        errors.forEach((e) => dispatch(actions.alert('error', e[0])));
      } else {
        dispatch(
          actions.alert(
            'error',
            'Oops! Something went wrong. Please try to reset your password again. If this error persists, please contact us.'
          )
        );
      }
    } else if (status === actionTypes.AUTH_RESET_SUCCESS) {
      dispatch(
        actions.alert('success', 'Your password has been reset successfully.')
      );
      this.props.router.push('/login');
    }
  }

  handleChange = (type, e) => {
    this.setState({ [type]: e.target.value });
  };

  send(e) {
    e.preventDefault();

    const { params, dispatch } = this.props;
    const { password, confirmPassword } = this.state;

    dispatch(actions.hideAlert());

    const uid = params.uid;
    const token = params.token;

    if (password !== confirmPassword) {
      dispatch(actions.alert('error', 'Passwords do not match.'));
    } else {
      dispatch(actions.resetPassword(token, uid, password));
    }
  }

  render() {
    const { status, email } = this.props;
    const { password, confirmPassword } = this.state;

    return (
      <div className="forgot-password">
        <h3 className="title">Reset your Password</h3>

        {status === actionTypes.AUTH_EMAIL_REQUEST ? (
          <p className="text-center">Loading your info ...</p>
        ) : status === actionTypes.AUTH_EMAIL_ERROR ? (
          <p className="text-red text-center">Invalid token url.</p>
        ) : (
          <div>
            <p>Reset password for {email}.</p>
            <hr className="transparent" />

            <Form onSubmit={(e) => this.send(e)}>
              <FormGroup>
                <FormControl
                  type="password"
                  placeholder="New password"
                  autoFocus
                  value={password}
                  onChange={(e) => this.handleChange('password', e)}
                />
              </FormGroup>
              <FormGroup>
                <FormControl
                  type="password"
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={(e) => this.handleChange('confirmPassword', e)}
                />
              </FormGroup>
              <FormGroup className="actions mt-30px">
                <div></div>
                <div>
                  <button
                    type="submit"
                    disabled={status === actionTypes.AUTH_RESET_REQUEST}
                  >
                    {status === actionTypes.AUTH_RESET_REQUEST && (
                      <i className="fa fa-refresh fa-spin fa-fw mr-5px"></i>
                    )}
                    reset my password
                  </button>
                </div>
              </FormGroup>
            </Form>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  status: state.auth.status,
  email: state.auth.email,
  error: state.auth.error,
});

export default connect(mapStateToProps)(ResetPassword);



// WEBPACK FOOTER //
// src/components/Auth/ResetPassword.jsx